{
  "30": "30",
  "$50.00": "$50.00",
  "* No interest will be charged on the promo balance if you pay it off, in full, within the promo period. If you do not, interest will be charged on the promo balance from the purchase date. The required minimum monthly payments may or may not pay off the promo balance before the end of the promo period, depending on purchase amount, promo length and payment allocation. Regular account terms apply to non-promo purchases and, after promo period ends, to the promo balance. New Accounts as of 5/30/2024: Purchase APR is 32.99%. Penalty APR is 39.99%. Minimum Interest Charge is $2. Existing cardholders: See your credit card agreement terms. Subject to credit approval. We reserve the right to discontinue or alter the terms of this offer at any time.": "* No interest will be charged on the promo balance if you pay it off, in full, within the promo period. If you do not, interest will be charged on the promo balance from the purchase date. The required minimum monthly payments may or may not pay off the promo balance before the end of the promo period, depending on purchase amount, promo length and payment allocation. Regular account terms apply to non-promo purchases and, after promo period ends, to the promo balance. New Accounts as of 5/30/2024: Purchase APR is 32.99%. Penalty APR is 39.99%. Minimum Interest Charge is $2. Existing cardholders: See your credit card agreement terms. Subject to credit approval. We reserve the right to discontinue or alter the terms of this offer at any time.",
  "** Interest will be charged on promo purchase from the purchase date at a reduced APR shown and fixed. Monthly payments are required until paid in full. These payments may be higher than the minimum payment that would be required if the purchase was a non-promo purchase. Regular account terms apply to non-promo purchases. Accounts as of 5/30/2024: Purchase APR is 32.99%. Penalty APR is 39.99%. Minimum Interest Charge is $2. Existing cardholders: See your credit card agreement terms. Subject to credit approval. We reserve the right to discontinue or alter the terms of this offer at any time.": "** Interest will be charged on promo purchase from the purchase date at a reduced APR shown and fixed. Monthly payments are required until paid in full. These payments may be higher than the minimum payment that would be required if the purchase was a non-promo purchase. Regular account terms apply to non-promo purchases. Accounts as of 5/30/2024: Purchase APR is 32.99%. Penalty APR is 39.99%. Minimum Interest Charge is $2. Existing cardholders: See your credit card agreement terms. Subject to credit approval. We reserve the right to discontinue or alter the terms of this offer at any time.",
  "...See more": "...See more",
  "1 Appointment Status": "1 Appointment Status",
  "1 Payer": "1 Payer",
  "1 day overdue": "1 day overdue",
  "30 Days Free Trial of Weave Insurance Eligibility": "30 Days Free Trial of Weave Insurance Eligibility",
  "30 days overdue": "30 days overdue",
  "30+ days overdue": "30+ days overdue",
  "404 - Page Not Found": "404 - Page Not Found",
  "<0><0>Call to</0> <2>{notification.payload.recipientLocationName}</2></0>": "<0><0>Call to</0> <2>{notification.payload.recipientLocationName}</2></0>",
  "<0><0>This estimated payment: Equals the greater of (a) the Amount Financed divided by the number of months in the promo period rounded to the next highest whole dollar, in which case it is only a Suggested Payment, or (b) $30, the currently required minimum monthly payment.</0><1>Would pay off the Amount Financed within the Payoff Period, but only if there are no other balances on your account at any time during the promo period and you make your payments on time. Your total payments will equal the Amount Financed</1></0>": "<0><0>This estimated payment: Equals the greater of (a) the Amount Financed divided by the number of months in the promo period rounded to the next highest whole dollar, in which case it is only a Suggested Payment, or (b) $30, the currently required minimum monthly payment.</0><1>Would pay off the Amount Financed within the Payoff Period, but only if there are no other balances on your account at any time during the promo period and you make your payments on time. Your total payments will equal the Amount Financed</1></0>",
  "<0>Contrast Ratio: </0><1>{ratio}:1</1>": "<0>Contrast Ratio: </0><1>{ratio}:1</1>",
  "<0>The minimum contrast ratio for normal text is <2>4.5:1</2>. </0><1>To improve the contrast ratio, consider choosing a darker color.</1>": "<0>The minimum contrast ratio for normal text is <2>4.5:1</2>. </0><1>To improve the contrast ratio, consider choosing a darker color.</1>",
  "<0>You've been <1>@mentioned</1></0>": "<0>You've been <1>@mentioned</1></0>",
  "A new version is available: {{version}}": "A new version is available: {{version}}",
  "A printed receipt will be generated automatically.": "A printed receipt will be generated automatically.",
  "A receipt will be sent to this address": "A receipt will be sent to this address",
  "AI Receptionist": "AI Receptionist",
  "AI Receptionist continued the conversation over text.": "AI Receptionist continued the conversation over text.",
  "AI Receptionist failed to answer this call.": "AI Receptionist failed to answer this call.",
  "AI Receptionist successfully assisted the patient": "AI Receptionist successfully assisted the patient",
  "AI Receptionist transferred the call to your office.": "AI Receptionist transferred the call to your office.",
  "AI Settings": "AI Settings",
  "APPOINTMENT DATE": "APPOINTMENT DATE",
  "APPOINTMENT DATE TIME": "APPOINTMENT DATE TIME",
  "APPOINTMENT DAY OF MONTH": "APPOINTMENT DAY OF MONTH",
  "APPOINTMENT MONTH": "APPOINTMENT MONTH",
  "APPOINTMENT TIME": "APPOINTMENT TIME",
  "APPOINTMENT WEEKDAY": "APPOINTMENT WEEKDAY",
  "About Page": "About Page",
  "Accessibility": "Accessibility",
  "Accessibility Preferences": "Accessibility Preferences",
  "Account Details": "Account Details",
  "Account Holder": "Account Holder",
  "Account Number": "Account Number",
  "Action Required": "Action Required",
  "Action menu": "Action menu",
  "Actions": "Actions",
  "Active": "Active",
  "Add Card": "Add Card",
  "Add Payer Credential": "Add Payer Credential",
  "Add Payer NPI": "Add Payer NPI",
  "Add Text Signature": "Add Text Signature",
  "Add note": "Add note",
  "Add-ons": "Add-ons",
  "Address": "Address",
  "Address Line 2 cannot exceed 55 characters": "Address Line 2 cannot exceed 55 characters",
  "Address cannot exceed 55 characters": "Address cannot exceed 55 characters",
  "Address is required": "Address is required",
  "Adjust image": "Adjust image",
  "Adjustments": "Adjustments",
  "Advanced": "Advanced",
  "Agree to Terms": "Agree to Terms",
  "Alerts": "Alerts",
  "All Appointment Statuses": "All Appointment Statuses",
  "All Payers": "All Payers",
  "Alternate Payer IDs": "Alternate Payer IDs",
  "Amount Due": "Amount Due",
  "Amount Financed": "Amount Financed",
  "Amount Financed: <1>{currency(amountInDollars, { decimals: 2 })}</1>": "Amount Financed: <1>{currency(amountInDollars, { decimals: 2 })}</1>",
  "Amount Owed": "Amount Owed",
  "Amount of initial sale/transaction": "Amount of initial sale/transaction",
  "An error occurred while generating the report.": "An error occurred while generating the report.",
  "An error occurred while updating the task": "An error occurred while updating the task",
  "An error occurred while verifying the address": "An error occurred while verifying the address",
  "An unknown error occurred": "An unknown error occurred",
  "An unknown error occurred. Please try again.": "An unknown error occurred. Please try again.",
  "An unknown validation error occurred.": "An unknown validation error occurred.",
  "Answer": "Answer",
  "Applicant ID Verification": "Applicant ID Verification",
  "Applicant Information": "Applicant Information",
  "Applicant Name": "Applicant Name",
  "Applicant Prequalified": "Applicant Prequalified",
  "Applicant approved": "Applicant approved",
  "Applicant must review and sign the physical copy.": "Applicant must review and sign the physical copy.",
  "Application Confirmation": "Application Confirmation",
  "Application Revision Date": "Application Revision Date",
  "Application Status Unknown": "Application Status Unknown",
  "Application Version: {{version}}": "Application Version: {{version}}",
  "Application declined": "Application declined",
  "Application pending": "Application pending",
  "Apply": "Apply",
  "Apply Filter": "Apply Filter",
  "Appointment": "Appointment",
  "Appointment Date": "Appointment Date",
  "Appointment Datetime": "Appointment Datetime",
  "Appointment Day": "Appointment Day",
  "Appointment Day Ordinal": "Appointment Day Ordinal",
  "Appointment Day of Month": "Appointment Day of Month",
  "Appointment Month": "Appointment Month",
  "Appointment Time": "Appointment Time",
  "Appointment Weekday": "Appointment Weekday",
  "Appt Date": "Appt Date",
  "Appt Datetime": "Appt Datetime",
  "Appt Day": "Appt Day",
  "Appt Day Ordinal": "Appt Day Ordinal",
  "Appt Day of Month": "Appt Day of Month",
  "Appt Month": "Appt Month",
  "Appt Time": "Appt Time",
  "Appt Weekday": "Appt Weekday",
  "Are you sure you want to delete this note?": "Are you sure you want to delete this note?",
  "Are you sure you want to delete this {{contactLabel}}? This action cannot be undone.": "Are you sure you want to delete this {{contactLabel}}? This action cannot be undone.",
  "Arrival Time": "Arrival Time",
  "Ask the patient/client if they would like to accept this offer of credit and submit a full credit application, which includes a hard inquiry on their credit report.<1></1><2></2>If the customer chooses not to accept and apply now, you will need to restart the prequalification later if they change their mind.": "Ask the patient/client if they would like to accept this offer of credit and submit a full credit application, which includes a hard inquiry on their credit report.<1></1><2></2>If the customer chooses not to accept and apply now, you will need to restart the prequalification later if they change their mind.",
  "Auth Failed": "Auth Failed",
  "Auto MFA Not Setup": "Auto MFA Not Setup",
  "Auto MFA Setup Guide": "Auto MFA Setup Guide",
  "Available Credit": "Available Credit",
  "Available: <1>{formattedAmount}</1> as of {date}": "Available: <1>{formattedAmount}</1> as of {date}",
  "BNPL": "BNPL",
  "BNPL Link": "BNPL Link",
  "BNPL Payment Link": "BNPL Payment Link",
  "BNPL Payment URL": "BNPL Payment URL",
  "BNPL URL": "BNPL URL",
  "BUY NOW PAY LATER LINK": "BUY NOW PAY LATER LINK",
  "Back": "Back",
  "Back to Promotions": "Back to Promotions",
  "Balance Created": "Balance Created",
  "Begin Setup": "Begin Setup",
  "Best Name": "Best Name",
  "Beta": "Beta",
  "Birthdate": "Birthdate",
  "Birthdate cannot be in the future": "Birthdate cannot be in the future",
  "Birthdate is required": "Birthdate is required",
  "Blind": "Blind",
  "Blog": "Blog",
  "Break": "Break",
  "Breed": "Breed",
  "Business Preferences": "Business Preferences",
  "Button link is required.": "Button link is required.",
  "Button text is required.": "Button text is required.",
  "Buy Now Pay Later": "Buy Now Pay Later",
  "Buy Now Pay Later Link": "Buy Now Pay Later Link",
  "Buy Now Pay Later Payment Link": "Buy Now Pay Later Payment Link",
  "Buy Now Pay Later Payment URL": "Buy Now Pay Later Payment URL",
  "Buy Now Pay Later URL": "Buy Now Pay Later URL",
  "By continuing, I affirm the applicant has authorized Synchrony Bank to obtain information from consumer\n        reporting agencies to determine if they are prequalified for credit. In addition, if they are prequalified, the\n        applicant acknowledges that they will need to accept the credit offer and complete the application process. I\n        affirm the applicant acknowledges that they are limited to 4 prequalification attempts per day; after their 4th\n        attempt any future requests will not be accepted for the remainder of that day.": "By continuing, I affirm the applicant has authorized Synchrony Bank to obtain information from consumer\n        reporting agencies to determine if they are prequalified for credit. In addition, if they are prequalified, the\n        applicant acknowledges that they will need to accept the credit offer and complete the application process. I\n        affirm the applicant acknowledges that they are limited to 4 prequalification attempts per day; after their 4th\n        attempt any future requests will not be accepted for the remainder of that day.",
  "COB": "COB",
  "Call Analyzed by Call Intelligence": "Call Analyzed by Call Intelligence",
  "Call Record not allowed for this location. Please switch to the appropriate location to view the call record.": "Call Record not allowed for this location. Please switch to the appropriate location to view the call record.",
  "Caller hung up before AI Receptionist could determine the outcome.": "Caller hung up before AI Receptionist could determine the outcome.",
  "Cancel": "Cancel",
  "Cancel Application": "Cancel Application",
  "Cardholder": "Cardholder",
  "CareCredit": "CareCredit",
  "CareCredit was unable to approve this application at this time.  A written explanation will be sent in the mail within 7-10 days regarding the reasons for the decision and the source of the information utilized.  It will include a number to call for questions.": "CareCredit was unable to approve this application at this time.  A written explanation will be sent in the mail within 7-10 days regarding the reasons for the decision and the source of the information utilized.  It will include a number to call for questions.",
  "Charges": "Charges",
  "Check Now": "Check Now",
  "Check Prequalification": "Check Prequalification",
  "Check the box below only after obtaining the physical signature": "Check the box below only after obtaining the physical signature",
  "Choose how you want your desktop app to look.": "Choose how you want your desktop app to look.",
  "City": "City",
  "City cannot exceed 45 characters": "City cannot exceed 45 characters",
  "City is required": "City is required",
  "Clear All": "Clear All",
  "Click to sort ascending": "Click to sort ascending",
  "Click to sort descending": "Click to sort descending",
  "Close": "Close",
  "Close Window": "Close Window",
  "Collapse": "Collapse",
  "Collapse All": "Collapse All",
  "Collect": "Collect",
  "Collection Amount": "Collection Amount",
  "Collections Amount": "Collections Amount",
  "Color": "Color",
  "Color Preferences": "Color Preferences",
  "Compact View": "Compact View",
  "Company Name": "Company Name",
  "Complete CareCredit prequalification on patient's behalf": "Complete CareCredit prequalification on patient's behalf",
  "Complete the transaction at patient’s request": "Complete the transaction at patient’s request",
  "Complete with Surcharge": "Complete with Surcharge",
  "Condense row": "Condense row",
  "Confirm Applicant Information": "Confirm Applicant Information",
  "Confirm and submit below": "Confirm and submit below",
  "Confirmation": "Confirmation",
  "Confirmation Link": "Confirmation Link",
  "Connect Payers": "Connect Payers",
  "Connect to increase coverage": "Connect to increase coverage",
  "Connected": "Connected",
  "Connected Device": "Connected Device",
  "Connected Device is silenced in workspace mode.": "Connected Device is silenced in workspace mode.",
  "Contact Page": "Contact Page",
  "Copied Theme Code": "Copied Theme Code",
  "Copy Current URL": "Copy Current URL",
  "Copy Request Link": "Copy Request Link",
  "Copy Theme Code": "Copy Theme Code",
  "Coverage Level": "Coverage Level",
  "Current Organization in Use": "Current Organization in Use",
  "Currently showing EDI response. Connect your payer credentials to view the full website report.": "Currently showing EDI response. Connect your payer credentials to view the full website report.",
  "Currently showing EDI response. Your payer credentials are connected. Retry to view the full website report.": "Currently showing EDI response. Your payer credentials are connected. Retry to view the full website report.",
  "Custom": "Custom",
  "Custom Link": "Custom Link",
  "Custom Review": "Custom Review",
  "Customer Accepts": "Customer Accepts",
  "Customer ID Verification": "Customer ID Verification",
  "Customer can complete approval and pay after.": "Customer can complete approval and pay after.",
  "Customize Your App": "Customize Your App",
  "DOB": "DOB",
  "Date": "Date",
  "Date & Time": "Date & Time",
  "Date + Time": "Date + Time",
  "Date Time": "Date Time",
  "Date and Time": "Date and Time",
  "Date of Birth": "Date of Birth",
  "Datetime": "Datetime",
  "Day": "Day",
  "Day Ordinal": "Day Ordinal",
  "Day of Month": "Day of Month",
  "Days Overdue": "Days Overdue",
  "Declined": "Declined",
  "Deductible": "Deductible",
  "Deductibles": "Deductibles",
  "Deferred Interest": "Deferred Interest",
  "Delete Image": "Delete Image",
  "Delete Request": "Delete Request",
  "Deselect": "Deselect",
  "Device Connection Changed": "Device Connection Changed",
  "Dial": "Dial",
  "Different Weave Views": "Different Weave Views",
  "Disconnected": "Disconnected",
  "Display Until Dismissed": "Display Until Dismissed",
  "Display for 4 Seconds": "Display for 4 Seconds",
  "Don’t worry, you can change this later in your Settings.": "Don’t worry, you can change this later in your Settings.",
  "Downgrades": "Downgrades",
  "Due today": "Due today",
  "During the period from {{startDate}} to {{endDate}}": "During the period from {{startDate}} to {{endDate}}",
  "EDI": "EDI",
  "EDI Verified": "EDI Verified",
  "Earlier": "Earlier",
  "Edit": "Edit",
  "Edit Text Signature": "Edit Text Signature",
  "Effective Date": "Effective Date",
  "Eg: D0801, Family": "Eg: D0801, Family",
  "Eligibility Report Available in Large Mode Only": "Eligibility Report Available in Large Mode Only",
  "Email": "Email",
  "Email (Optional)": "Email (Optional)",
  "Email Address": "Email Address",
  "Email Receipt (Optional)": "Email Receipt (Optional)",
  "Email cannot exceed 50 characters": "Email cannot exceed 50 characters",
  "Enable Auto MFA": "Enable Auto MFA",
  "End Date": "End Date",
  "Enter a link...": "Enter a link...",
  "Error": "Error",
  "Error Details": "Error Details",
  "Error Type:": "Error Type:",
  "Error generating smart draft": "Error generating smart draft",
  "Error processing the selected card. Please check the payment details and try again.": "Error processing the selected card. Please check the payment details and try again.",
  "Error submitting payment. Please try again.": "Error submitting payment. Please try again.",
  "Event ID:": "Event ID:",
  "Exit Setup": "Exit Setup",
  "Exp. Date": "Exp. Date",
  "Expand All": "Expand All",
  "Expand row": "Expand row",
  "Expanded View": "Expanded View",
  "Expiration Date": "Expiration Date",
  "Expiration date is required": "Expiration date is required",
  "Expiration date must be in the future": "Expiration date must be in the future",
  "FAQ Page": "FAQ Page",
  "Facebook Review": "Facebook Review",
  "Failed": "Failed",
  "Failed to add note.": "Failed to add note.",
  "Failed to copy shortlink.": "Failed to copy shortlink.",
  "Failed to delete note.": "Failed to delete note.",
  "Failed to get application result.": "Failed to get application result.",
  "Failed to load gifs": "Failed to load gifs",
  "Failed to load location information. Please contact support at (888) 579-5668 option 1": "Failed to load location information. Please contact support at (888) 579-5668 option 1",
  "Failed to load notes.": "Failed to load notes.",
  "Failed to parse error message": "Failed to parse error message",
  "Failed to save PDF Configuration: {{error}}": "Failed to save PDF Configuration: {{error}}",
  "Failed to update note.": "Failed to update note.",
  "Failed to {{action}} average appointment value. Please try again.": "Failed to {{action}} average appointment value. Please try again.",
  "Family Name": "Family Name",
  "Favorite Procedures": "Favorite Procedures",
  "Fax Received": "Fax Received",
  "Fax Send Failed": "Fax Send Failed",
  "Fax failed to send, please try again": "Fax failed to send, please try again",
  "Feedback": "Feedback",
  "Fees": "Fees",
  "First Name": "First Name",
  "First name cannot exceed 40 characters": "First name cannot exceed 40 characters",
  "First name is required": "First name is required",
  "Fixed Pay Reduced APR": "Fixed Pay Reduced APR",
  "Follow these steps to complete application": "Follow these steps to complete application",
  "Font Preferences": "Font Preferences",
  "Font Size": "Font Size",
  "Given Name": "Given Name",
  "Go Back": "Go Back",
  "Go Forward": "Go Forward",
  "Go home": "Go home",
  "Go to Home Page": "Go to Home Page",
  "Google Review": "Google Review",
  "Group Name": "Group Name",
  "Group Number": "Group Number",
  "Have applicant sign the printed application": "Have applicant sign the printed application",
  "Help Center": "Help Center",
  "Hi this is Amelia Walker I have an appointment scheduled for tomorrow and I'm not going to make it. I was hoping I could reschedule for next week, please give me a call back on my cell phone, thank you.": "Hi this is Amelia Walker I have an appointment scheduled for tomorrow and I'm not going to make it. I was hoping I could reschedule for next week, please give me a call back on my cell phone, thank you.",
  "History": "History",
  "Hmm...": "Hmm...",
  "Housing Status": "Housing Status",
  "How would you like to experience notifications?": "How would you like to experience notifications?",
  "How would you like to process the CareCredit Prequalification?": "How would you like to process the CareCredit Prequalification?",
  "How would you like to process the CareCredit payment?": "How would you like to process the CareCredit payment?",
  "How would you like to start using Weave today?": "How would you like to start using Weave today?",
  "I agree": "I agree",
  "I certify that the application information was provided by the applicant. I have provided all required notices and statements, including a copy of the Synchrony Application which contains the Synchrony Account Agreement terms, to the applicant prior to submitting this application. I am submitting this application on behalf of the applicant based on the applicant having signed either (i) a printed version of this online application (in English or Spanish, as applicable) or (ii) a pre-printed paper copy of the Synchrony Application (in English or Spanish, as applicable).": "I certify that the application information was provided by the applicant. I have provided all required notices and statements, including a copy of the Synchrony Application which contains the Synchrony Account Agreement terms, to the applicant prior to submitting this application. I am submitting this application on behalf of the applicant based on the applicant having signed either (i) a printed version of this online application (in English or Spanish, as applicable) or (ii) a pre-printed paper copy of the Synchrony Application (in English or Spanish, as applicable).",
  "ID Expiration Date": "ID Expiration Date",
  "ID Issuing Country": "ID Issuing Country",
  "ID Issuing State": "ID Issuing State",
  "ID Number": "ID Number",
  "ID Type": "ID Type",
  "ID expiration date is required": "ID expiration date is required",
  "ID expiration date must be in the future": "ID expiration date must be in the future",
  "ID issuing country must be 2 or 3 letter country code": "ID issuing country must be 2 or 3 letter country code",
  "ID number cannot exceed 30 characters": "ID number cannot exceed 30 characters",
  "ID number is required": "ID number is required",
  "IMPORTANT: The information about the monthly payment shown assumes the promo financing offer above is applied to the Amount Financed:": "IMPORTANT: The information about the monthly payment shown assumes the promo financing offer above is applied to the Amount Financed:",
  "IMPORTANT: The information about the required fixed monthly payment shown assumes the following promo financing offer is applied to the Amount Financed:": "IMPORTANT: The information about the required fixed monthly payment shown assumes the following promo financing offer is applied to the Amount Financed:",
  "IN NETWORK": "IN NETWORK",
  "If the Amount Financed is not paid in full within the promo period, interest will be charged to your account from the purchase date and your total payments will be greater than the Amount Financed.": "If the Amount Financed is not paid in full within the promo period, interest will be charged to your account from the purchase date and your total payments will be greater than the Amount Financed.",
  "Ignore": "Ignore",
  "Import Theme": "Import Theme",
  "Import Your Theme": "Import Your Theme",
  "In Progress": "In Progress",
  "In-Network": "In-Network",
  "Incoming Call": "Incoming Call",
  "Insurance": "Insurance",
  "Insurance & Status": "Insurance & Status",
  "Insurance Remaining": "Insurance Remaining",
  "Insurance Type": "Insurance Type",
  "Invalid IP or CIDR range": "Invalid IP or CIDR range",
  "Invalid SAML metadata: missing EntityDescriptor.": "Invalid SAML metadata: missing EntityDescriptor.",
  "Invalid date format": "Invalid date format",
  "Invalid email address": "Invalid email address",
  "Invalid information provided.": "Invalid information provided.",
  "Invalid or untrusted URL": "Invalid or untrusted URL",
  "Invalid shortlink.": "Invalid shortlink.",
  "Invalid theme code": "Invalid theme code",
  "Issuing State": "Issuing State",
  "It looks like you don't have permission to view this page. Please contact your system administrator for more information.": "It looks like you don't have permission to view this page. Please contact your system administrator for more information.",
  "Language": "Language",
  "Last 30 Days": "Last 30 Days",
  "Last 7 Days": "Last 7 Days",
  "Last Name": "Last Name",
  "Last Week": "Last Week",
  "Last name cannot exceed 40 characters": "Last name cannot exceed 40 characters",
  "Last name is required": "Last name is required",
  "Learn More": "Learn More",
  "Lengthen": "Lengthen",
  "Less than a minute": "Less than a minute",
  "Let’s get started!": "Let’s get started!",
  "Location": "Location",
  "Location Info": "Location Info",
  "Location Name": "Location Name",
  "Location Phone": "Location Phone",
  "Location Phone Number": "Location Phone Number",
  "Locations": "Locations",
  "Logging in...": "Logging in...",
  "Looks like this pet is all caught up for now.": "Looks like this pet is all caught up for now.",
  "Mailing Address": "Mailing Address",
  "Mailing Address Line 1": "Mailing Address Line 1",
  "Mailing Address Line 2 (Optional)": "Mailing Address Line 2 (Optional)",
  "Make Appointment Link": "Make Appointment Link",
  "Make a Payment": "Make a Payment",
  "Manage": "Manage",
  "Manage All": "Manage All",
  "Manage My Support Cases": "Manage My Support Cases",
  "Managing settings for {{locationCount}}": "Managing settings for {{locationCount}}",
  "Map": "Map",
  "Mark as Read": "Mark as Read",
  "Mark as recorded": "Mark as recorded",
  "Mark as unrecorded": "Mark as unrecorded",
  "Mark completed": "Mark completed",
  "Mark uncompleted": "Mark uncompleted",
  "Matching Organizations": "Matching Organizations",
  "Maximize": "Maximize",
  "Maximize Window": "Maximize Window",
  "Maximum": "Maximum",
  "Member ID": "Member ID",
  "Method:": "Method:",
  "Middle Name (Optional)": "Middle Name (Optional)",
  "Middle name cannot exceed 30 characters": "Middle name cannot exceed 30 characters",
  "Military Branch": "Military Branch",
  "Minimize Window": "Minimize Window",
  "Missed Call": "Missed Call",
  "Missing Form": "Missing Form",
  "Missing Tooth Clause": "Missing Tooth Clause",
  "Month": "Month",
  "Monthly Net Income": "Monthly Net Income",
  "Monthly Net Income (From all sources)": "Monthly Net Income (From all sources)",
  "More": "More",
  "More Notifications": "More Notifications",
  "More actions": "More actions",
  "Moved to Timeline": "Moved to Timeline",
  "Multi Visits Paid On": "Multi Visits Paid On",
  "My profile": "My profile",
  "N/A": "N/A",
  "Net Income Disclosure": "Net Income Disclosure",
  "Network Name": "Network Name",
  "New": "New",
  "New Appointment": "New Appointment",
  "New Appointment Booked from Waitlist": "New Appointment Booked from Waitlist",
  "New Chat Message": "New Chat Message",
  "New Fax": "New Fax",
  "New Follow Up": "New Follow Up",
  "New Form Submission": "New Form Submission",
  "New Inbound Fax Received": "New Inbound Fax Received",
  "New Message": "New Message",
  "New Missed Call": "New Missed Call",
  "New Out of Office Event": "New Out of Office Event",
  "New Patient Followup": "New Patient Followup",
  "New Payment": "New Payment",
  "New Prequalification": "New Prequalification",
  "New Review": "New Review",
  "New Review Request": "New Review Request",
  "New SMS Message": "New SMS Message",
  "New Schedule Request": "New Schedule Request",
  "New Team Chat": "New Team Chat",
  "New Voicemail": "New Voicemail",
  "Next": "Next",
  "Next Day": "Next Day",
  "No": "No",
  "No Device Connected": "No Device Connected",
  "No Gifs to display": "No Gifs to display",
  "No Interest if Paid in Full Within {{months}} Months*": "No Interest if Paid in Full Within {{months}} Months*",
  "No Thanks": "No Thanks",
  "No data to display": "No data to display",
  "No insurance alerts found for this time period": "No insurance alerts found for this time period",
  "No location selected": "No location selected",
  "No matching addresses found. Please check the address details and try again.": "No matching addresses found. Please check the address details and try again.",
  "No tasks to show": "No tasks to show",
  "No valid phone number": "No valid phone number",
  "Not Accessible in current scope - {{scopeName}}": "Not Accessible in current scope - {{scopeName}}",
  "Not Connected": "Not Connected",
  "Notification Center": "Notification Center",
  "Notification Preference": "Notification Preference",
  "Notifications Paused": "Notifications Paused",
  "OFFICE NAME": "OFFICE NAME",
  "OFFICE PHONE NUMBER": "OFFICE PHONE NUMBER",
  "ONLINE BILL PAY LINK": "ONLINE BILL PAY LINK",
  "OPENING DATETIME": "OPENING DATETIME",
  "OPENINGS DATETIME": "OPENINGS DATETIME",
  "OUT OF NETWORK": "OUT OF NETWORK",
  "Obtain Applicant Signature": "Obtain Applicant Signature",
  "Office Info": "Office Info",
  "Office Name": "Office Name",
  "Office Phone": "Office Phone",
  "Office Phone Number": "Office Phone Number",
  "Office User": "Office User",
  "On {{date}}": "On {{date}}",
  "One or more locations do not have access to this form or packet. Inspect this element to resolve this issue.": "One or more locations do not have access to this form or packet. Inspect this element to resolve this issue.",
  "One or more locations have not connected to Facebook in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not connected to Facebook in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not connected to Google in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not connected to Google in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not defined an email address. Inspect this element to resolve this issue.": "One or more locations have not defined an email address. Inspect this element to resolve this issue.",
  "One or more locations have not properly configured their schedule yet.": "One or more locations have not properly configured their schedule yet.",
  "One or more locations have not selected a phone number in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not selected a phone number in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a custom reviews link in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a custom reviews link in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their FAQ page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their FAQ page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their about page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their about page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their blog in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their blog in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their contact page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their contact page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their custom other page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their custom other page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their help center in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their help center in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their map in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their map in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their promotional page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their promotional page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their referral page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their referral page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their shop in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their shop in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set a link to their web page in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set a link to their web page in Brand Settings. Inspect this element to resolve this issue.",
  "One or more locations have not set an address in Brand Settings. Inspect this element to resolve this issue.": "One or more locations have not set an address in Brand Settings. Inspect this element to resolve this issue.",
  "Online Bill": "Online Bill",
  "Online Bill Pay": "Online Bill Pay",
  "Online Bill Pay Link": "Online Bill Pay Link",
  "Oops, something went wrong.": "Oops, something went wrong.",
  "Open": "Open",
  "Open Advanced Preferences": "Open Advanced Preferences",
  "Open Settings Menu": "Open Settings Menu",
  "Opening Date Time": "Opening Date Time",
  "Opening Datetime": "Opening Datetime",
  "Openings Date Time": "Openings Date Time",
  "Openings Datetime": "Openings Datetime",
  "Order Type": "Order Type",
  "Other": "Other",
  "Out-Network": "Out-Network",
  "Out-Of-Network": "Out-Of-Network",
  "Out-of-Network": "Out-of-Network",
  "Outstanding Amount": "Outstanding Amount",
  "Overdue Services": "Overdue Services",
  "Owner": "Owner",
  "PAYMENT LINK": "PAYMENT LINK",
  "PDF Configuration saved successfully": "PDF Configuration saved successfully",
  "Page {{currentPage}} of {{maxPage}}": "Page {{currentPage}} of {{maxPage}}",
  "Pair New Device": "Pair New Device",
  "Paste your codes into this box to generate your gradient.": "Paste your codes into this box to generate your gradient.",
  "Patient": "Patient",
  "Patient Details": "Patient Details",
  "Patient Information": "Patient Information",
  "Patient Name": "Patient Name",
  "Patient Reminders": "Patient Reminders",
  "Pause": "Pause",
  "Pay Link": "Pay Link",
  "Pay URL": "Pay URL",
  "Payer Connection Guide": "Payer Connection Guide",
  "Payer Details": "Payer Details",
  "Payer ID": "Payer ID",
  "Payer Name": "Payer Name",
  "Payer Reconnection Guide": "Payer Reconnection Guide",
  "Payer credentials are missing. Insurance eligibility results are limited until they are connected.": "Payer credentials are missing. Insurance eligibility results are limited until they are connected.",
  "Payment Link": "Payment Link",
  "Payment URL": "Payment URL",
  "Payment link copied!": "Payment link copied!",
  "Payments": "Payments",
  "Pending": "Pending",
  "Pending Verification": "Pending Verification",
  "Personal Preferences": "Personal Preferences",
  "Pet": "Pet",
  "Pet Name": "Pet Name",
  "Phone": "Phone",
  "Phone Number": "Phone Number",
  "Phone Number Type": "Phone Number Type",
  "Phone number must be 10 digits": "Phone number must be 10 digits",
  "Pick your color theme.": "Pick your color theme.",
  "Please add the NPI and Provider PIN under the Payer section in the Payer Management screen.": "Please add the NPI and Provider PIN under the Payer section in the Payer Management screen.",
  "Please enter a valid XML document.": "Please enter a valid XML document.",
  "Please enter valid email addresses, separated by commas if multiple": "Please enter valid email addresses, separated by commas if multiple",
  "Please have applicant call 1-800-924-2927 to proceed with the application. Reference application number <b>{{applicationNumber}}</b>. Additional information will be sent via mail from Synchrony Bank within 7-10 business days requesting this information.": "Please have applicant call 1-800-924-2927 to proceed with the application. Reference application number <b>{{applicationNumber}}</b>. Additional information will be sent via mail from Synchrony Bank within 7-10 business days requesting this information.",
  "Please note that enabling this feature may have negative impacts on Weave's usability.": "Please note that enabling this feature may have negative impacts on Weave's usability.",
  "Please restart the app to update": "Please restart the app to update",
  "Please review the following fields:": "Please review the following fields:",
  "Please select at least one location.": "Please select at least one location.",
  "Please share Promotional Financing Disclosures for Consumers (online or in-office brochure).": "Please share Promotional Financing Disclosures for Consumers (online or in-office brochure).",
  "Please try refreshing your browser window. If this issue continues, please contact Weave support, <2>here</2>.": "Please try refreshing your browser window. If this issue continues, please contact Weave support, <2>here</2>.",
  "Please wait while we retrieve the eligibility report.": "Please wait while we retrieve the eligibility report.",
  "Practice Address": "Practice Address",
  "Practice Email": "Practice Email",
  "Practice Info": "Practice Info",
  "Practice Name": "Practice Name",
  "Practice Phone": "Practice Phone",
  "Practice Phone Number": "Practice Phone Number",
  "Preapproved": "Preapproved",
  "Preferred Name": "Preferred Name",
  "Preparing {{fileName}} to download": "Preparing {{fileName}} to download",
  "Prequalification check": "Prequalification check",
  "Preview A Notification:": "Preview A Notification:",
  "Previous": "Previous",
  "Previous Day": "Previous Day",
  "Previous Page": "Previous Page",
  "Primary": "Primary",
  "Primary ID Type": "Primary ID Type",
  "Primary Insurance": "Primary Insurance",
  "Print Application": "Print Application",
  "Print Full Application": "Print Full Application",
  "Print Signature Page": "Print Signature Page",
  "Print the Application": "Print the Application",
  "Privacy Policy": "Privacy Policy",
  "Profile": "Profile",
  "Promo Period": "Promo Period",
  "Promotional Page": "Promotional Page",
  "Provider": "Provider",
  "Purchase Amount": "Purchase Amount",
  "Re-verification required": "Re-verification required",
  "Reacted to your message": "Reacted to your message",
  "Receipt Options": "Receipt Options",
  "Recently Added": "Recently Added",
  "Reconnect to restore coverage": "Reconnect to restore coverage",
  "Redirecting to New Page...": "Redirecting to New Page...",
  "Reduce claim denials and simplify your workflow with detailed, accurate insurance reports. Start your 30-day free trial now.": "Reduce claim denials and simplify your workflow with detailed, accurate insurance reports. Start your 30-day free trial now.",
  "Reduced APR and Fixed Monthly Payments Required Until Paid in Full**": "Reduced APR and Fixed Monthly Payments Required Until Paid in Full**",
  "Refer Weave": "Refer Weave",
  "Referral Page": "Referral Page",
  "Refine Selection": "Refine Selection",
  "Refund the payment": "Refund the payment",
  "Refunds": "Refunds",
  "Reload": "Reload",
  "Reload App": "Reload App",
  "Remaining/Max": "Remaining/Max",
  "Remaining/Max Amount": "Remaining/Max Amount",
  "Remind": "Remind",
  "Removing location access may prevent users from viewing or editing this auto&#8209;message.": "Removing location access may prevent users from viewing or editing this auto&#8209;message.",
  "Renewal Type": "Renewal Type",
  "Repeats “{{phoneTreeName}}”": "Repeats “{{phoneTreeName}}”",
  "Reply": "Reply",
  "Report Date": "Report Date",
  "Report Type": "Report Type",
  "Request Payment": "Request Payment",
  "Required Payments": "Required Payments",
  "Restart Now": "Restart Now",
  "Restore default sorting": "Restore default sorting",
  "Retry": "Retry",
  "Review and submit the information below and obtain the customer’s signature to complete the full credit application.": "Review and submit the information below and obtain the customer’s signature to complete the full credit application.",
  "SCHEDULE LINK": "SCHEDULE LINK",
  "SSN": "SSN",
  "SSN must be 9 digits": "SSN must be 9 digits",
  "SSN/TIN": "SSN/TIN",
  "Save": "Save",
  "Save Preferences": "Save Preferences",
  "Save changes": "Save changes",
  "Schedule": "Schedule",
  "Schedule Appointment Link": "Schedule Appointment Link",
  "Schedule Link": "Schedule Link",
  "Schedule Pulse": "Schedule Pulse",
  "Schedule Waitlist": "Schedule Waitlist",
  "Search Gif": "Search Gif",
  "Search to see organizations": "Search to see organizations",
  "Secondary": "Secondary",
  "Secondary Insurance": "Secondary Insurance",
  "See Details": "See Details",
  "Select": "Select",
  "Select All": "Select All",
  "Select All Available": "Select All Available",
  "Select An Organization": "Select An Organization",
  "Select Compact View": "Select Compact View",
  "Select Date": "Select Date",
  "Select Expanded View": "Select Expanded View",
  "Select Location": "Select Location",
  "Select Packet or Form": "Select Packet or Form",
  "Select Phone Type": "Select Phone Type",
  "Select Promotion": "Select Promotion",
  "Select this option to have your notifications appear for 4 seconds, then leave your screen.": "Select this option to have your notifications appear for 4 seconds, then leave your screen.",
  "Select this option to have your notifications stay on screen until you take action.": "Select this option to have your notifications stay on screen until you take action.",
  "Select to view name": "Select to view name",
  "Select to view names": "Select to view names",
  "Selected Organization (Pending)": "Selected Organization (Pending)",
  "Selected {{selected}} of {{total}}": "Selected {{selected}} of {{total}}",
  "Send Approval Link": "Send Approval Link",
  "Send SMS Message": "Send SMS Message",
  "Send a copy of the receipt to the contact’s email": "Send a copy of the receipt to the contact’s email",
  "Send link to patient's mobile number": "Send link to patient's mobile number",
  "Send link to patient’s mobile phone": "Send link to patient’s mobile phone",
  "Send prequalification link": "Send prequalification link",
  "Send transaction link to patient": "Send transaction link to patient",
  "Sent you GIFs and files": "Sent you GIFs and files",
  "Sent you GIFs and videos": "Sent you GIFs and videos",
  "Sent you a GIF": "Sent you a GIF",
  "Sent you a file": "Sent you a file",
  "Sent you a message": "Sent you a message",
  "Sent you a video": "Sent you a video",
  "Sent you an image": "Sent you an image",
  "Sent you images and GIFs": "Sent you images and GIFs",
  "Sent you images and files": "Sent you images and files",
  "Sent you images and videos": "Sent you images and videos",
  "Sent you multiple attachments": "Sent you multiple attachments",
  "Sent you videos and files": "Sent you videos and files",
  "Sent you {{count}} GIFs_one": "Sent you {{count}} GIFs",
  "Sent you {{count}} GIFs_other": "Sent you {{count}} GIFs",
  "Sent you {{count}} files_one": "Sent you {{count}} files",
  "Sent you {{count}} files_other": "Sent you {{count}} files",
  "Sent you {{count}} images_one": "Sent you {{count}} images",
  "Sent you {{count}} images_other": "Sent you {{count}} images",
  "Sent you {{count}} videos_one": "Sent you {{count}} videos",
  "Sent you {{count}} videos_other": "Sent you {{count}} videos",
  "Service Completion Date": "Service Completion Date",
  "Service Provider": "Service Provider",
  "Service completion date cannot be in the future": "Service completion date cannot be in the future",
  "Service completion date is required": "Service completion date is required",
  "Settings": "Settings",
  "Sex": "Sex",
  "Share Theme": "Share Theme",
  "Shop": "Shop",
  "Shorten": "Shorten",
  "Shortlink copied successfully!": "Shortlink copied successfully!",
  "Show More": "Show More",
  "Showing results for {{date}}, with {{network}}, {{insuranceType}} insurance, {{payers}}, and {{apptStatuses}} selected.": "Showing results for {{date}}, with {{network}}, {{insuranceType}} insurance, {{payers}}, and {{apptStatuses}} selected.",
  "Sign Out": "Sign Out",
  "Signing out": "Signing out",
  "Skip": "Skip",
  "Skip Setup": "Skip Setup",
  "Smart Reply generation failed. Try again.": "Smart Reply generation failed. Try again.",
  "Something went wrong": "Something went wrong",
  "Something went wrong.": "Something went wrong.",
  "Sorry, we couldn't find any results for ": "Sorry, we couldn't find any results for ",
  "Species": "Species",
  "Start Free Trial": "Start Free Trial",
  "Start Over": "Start Over",
  "Step 1 of 3": "Step 1 of 3",
  "Step 2 of 3": "Step 2 of 3",
  "Step 3 of 3": "Step 3 of 3",
  "Submission error. Please review the form and try again.": "Submission error. Please review the form and try again.",
  "Submit": "Submit",
  "Submit & Print Receipt": "Submit & Print Receipt",
  "Submit In-Office": "Submit In-Office",
  "Submit in-office": "Submit in-office",
  "Subscriber Date of Birth": "Subscriber Date of Birth",
  "Subscriber ID": "Subscriber ID",
  "Subscriber Name": "Subscriber Name",
  "Suffix (Optional)": "Suffix (Optional)",
  "Suggested Payments": "Suggested Payments",
  "Surname": "Surname",
  "Switch Locations": "Switch Locations",
  "Switch to Large Mode": "Switch to Large Mode",
  "System Health Alerts": "System Health Alerts",
  "TIME EARLY": "TIME EARLY",
  "TOA": "TOA",
  "Tag Applied to Fax": "Tag Applied to Fax",
  "Tag Applied to SMS Message": "Tag Applied to SMS Message",
  "Tag Applied to Voicemail": "Tag Applied to Voicemail",
  "Tags": "Tags",
  "Task Center": "Task Center",
  "Task Tray": "Task Tray",
  "Team Chat": "Team Chat",
  "Templates": "Templates",
  "Terms Agreement": "Terms Agreement",
  "Text": "Text",
  "The CVC is incorrect. Please update and try again.": "The CVC is incorrect. Please update and try again.",
  "The applicant is prequalified with a <b>{{ amount }} credit limit.</b>": "The applicant is prequalified with a <b>{{ amount }} credit limit.</b>",
  "The application will start with a prequalification, submitted at the applicant’s request. Prequalifying only requires a “soft” inquiry on the applicant’s credit report and has no impact on their credit bureau score.": "The application will start with a prequalification, submitted at the applicant’s request. Prequalifying only requires a “soft” inquiry on the applicant’s credit report and has no impact on their credit bureau score.",
  "The average appointment value has been successfully {{action}}": "The average appointment value has been successfully {{action}}",
  "The card declined. Please use a different card.": "The card declined. Please use a different card.",
  "The card failed to process. Please review the information and try again.": "The card failed to process. Please review the information and try again.",
  "The card has insufficient funds. Please use a different card.": "The card has insufficient funds. Please use a different card.",
  "The card is expired. Please use a different card.": "The card is expired. Please use a different card.",
  "The card number is incorrect. Please update and try again.": "The card number is incorrect. Please update and try again.",
  "The card returned a stolen. Please use a different card.": "The card returned a stolen. Please use a different card.",
  "The card returned as lost. Please use a different card.": "The card returned as lost. Please use a different card.",
  "The card returned as possibly fraudulent. Please use a different card.": "The card returned as possibly fraudulent. Please use a different card.",
  "The eligibility report is designed for larger screens to ensure optimal readability and interaction. Switch to large mode to view the detailed eligibility report.": "The eligibility report is designed for larger screens to ensure optimal readability and interaction. Switch to large mode to view the detailed eligibility report.",
  "The estimated required monthly payment shown equals the Amount Financed multiplied by 4.9876%. It is rounded to the next highest whole dollar. The sum of the required monthly payments will equal the cost of the Amount Financed. During the last month(s) of the promo period, the required monthly payment may be reduced due to the prior months' rounding. If you make these payments by the due date each month, you should pay off the Amount Financed within the promo period, if it is the only balance you are paying off. If you have other balances on your account, this payment will be added to any other minimum monthly payments.": "The estimated required monthly payment shown equals the Amount Financed multiplied by 4.9876%. It is rounded to the next highest whole dollar. The sum of the required monthly payments will equal the cost of the Amount Financed. During the last month(s) of the promo period, the required monthly payment may be reduced due to the prior months' rounding. If you make these payments by the due date each month, you should pay off the Amount Financed within the promo period, if it is the only balance you are paying off. If you have other balances on your account, this payment will be added to any other minimum monthly payments.",
  "The extension can't be edited because it falls outside the 9000 - 9099 range. Contact Weave Support if assistance is needed.": "The extension can't be edited because it falls outside the 9000 - 9099 range. Contact Weave Support if assistance is needed.",
  "The extension can't be edited due to pre-existing configurations. Contact Weave Support if assistance is needed.": "The extension can't be edited due to pre-existing configurations. Contact Weave Support if assistance is needed.",
  "The monthly payment shown may be greater than the required minimum monthly payment that will be on your billing statement when you use the promo financing offer.": "The monthly payment shown may be greater than the required minimum monthly payment that will be on your billing statement when you use the promo financing offer.",
  "The theme contains invalid color values.": "The theme contains invalid color values.",
  "There is a problem connecting to notifications!": "There is a problem connecting to notifications!",
  "There is a problem connecting to the websocket server!": "There is a problem connecting to the websocket server!",
  "There was an issue with your Affirm setup. Please use a different payment method and try again.": "There was an issue with your Affirm setup. Please use a different payment method and try again.",
  "There's Been An Error": "There's Been An Error",
  "This Month": "This Month",
  "This Week": "This Week",
  "This charge will include a surcharge. Please notify the customer of this...": "This charge will include a surcharge. Please notify the customer of this...",
  "This feature is only available in the desktop app. Please switch to the desktop app to customize your theme.": "This feature is only available in the desktop app. Please switch to the desktop app to customize your theme.",
  "This is a Shared Library": "This is a Shared Library",
  "This is sample data.": "This is sample data.",
  "This page is unavailable while a {{scopeName}} scope is selected. Switch your location selection to access this page.": "This page is unavailable while a {{scopeName}} scope is selected. Switch your location selection to access this page.",
  "This voicemail is restricted.": "This voicemail is restricted.",
  "Time": "Time",
  "Time Early": "Time Early",
  "To exit, manually choose and apply a location from the location picker.": "To exit, manually choose and apply a location from the location picker.",
  "Today": "Today",
  "Today {{time}}": "Today {{time}}",
  "Toggle advanced accessibility settings": "Toggle advanced accessibility settings",
  "Tomorrow": "Tomorrow",
  "Total Payments With Interest": "Total Payments With Interest",
  "Total Requested": "Total Requested",
  "Transaction Details": "Transaction Details",
  "Transfer Call": "Transfer Call",
  "Translations": "Translations",
  "Try Again": "Try Again",
  "Try again": "Try again",
  "URL:": "URL:",
  "Unable to load application document. Please try again.": "Unable to load application document. Please try again.",
  "Unable to load signature page document. Please try again.": "Unable to load signature page document. Please try again.",
  "Unable to retrieve CareCredit eligibility status at this time": "Unable to retrieve CareCredit eligibility status at this time",
  "Unable to sign in": "Unable to sign in",
  "Unhappy-call": "Unhappy-call",
  "Unknown": "Unknown",
  "Upcoming Services": "Upcoming Services",
  "Use": "Use",
  "Use Compact View": "Use Compact View",
  "Use Expanded View": "Use Expanded View",
  "Use this version of Weave for complex workflows, like taking payments from appointments, reviewing forms, and exploring analytics. Best suited for those who want to multitask and use Weave like a pro.": "Use this version of Weave for complex workflows, like taking payments from appointments, reviewing forms, and exploring analytics. Best suited for those who want to multitask and use Weave like a pro.",
  "Use this version of Weave for workflows like sending texts or checking voicemails one-by-one. Best suited for those who need side-by-side access with their practice management systems.": "Use this version of Weave for workflows like sending texts or checking voicemails one-by-one. Best suited for those who need side-by-side access with their practice management systems.",
  "Using DEV endpoints.": "Using DEV endpoints.",
  "Verification in Progress": "Verification in Progress",
  "Verified": "Verified",
  "Verify Manually": "Verify Manually",
  "Version Info": "Version Info",
  "Version {{currentVersion}}": "Version {{currentVersion}}",
  "Vertical": "Vertical",
  "View": "View",
  "View Details": "View Details",
  "View Message": "View Message",
  "View Report": "View Report",
  "View Request in Payments": "View Request in Payments",
  "View all": "View all",
  "View less": "View less",
  "View payment details": "View payment details",
  "View recent activity": "View recent activity",
  "Voicemail Preview": "Voicemail Preview",
  "Voicemail not allowed for this location. Please switch to the appropriate location to view the voicemail.": "Voicemail not allowed for this location. Please switch to the appropriate location to view the voicemail.",
  "Waiting for active user...": "Waiting for active user...",
  "Waitlist": "Waitlist",
  "Warm": "Warm",
  "Was due": "Was due",
  "We could not complete sign in. Please try again.": "We could not complete sign in. Please try again.",
  "We couldn’t find any matches for your search.": "We couldn’t find any matches for your search.",
  "We ran into an error on the page you're visiting. The error has been reported. If you continue experiencing this issue, please call Customer Support at <1>+1-888-579-5668</1>.": "We ran into an error on the page you're visiting. The error has been reported. If you continue experiencing this issue, please call Customer Support at <1>+1-888-579-5668</1>.",
  "We think you should review this": "We think you should review this",
  "We're currently retrieving your report. This may take 1-2 minutes.": "We're currently retrieving your report. This may take 1-2 minutes.",
  "Weave AI": "Weave AI",
  "Weave Help": "Weave Help",
  "Weave Support": "Weave Support",
  "Weave Training Camp": "Weave Training Camp",
  "Weave strives to serve all customers equally. If you would like to enable advanced accessibility settings, you can do so here.": "Weave strives to serve all customers equally. If you would like to enable advanced accessibility settings, you can do so here.",
  "Web": "Web",
  "Web Page": "Web Page",
  "Web Verified": "Web Verified",
  "Web Version Published At: {{publishedAt}}": "Web Version Published At: {{publishedAt}}",
  "Web Version: {{version}}": "Web Version: {{version}}",
  "Web and EDI Failed": "Web and EDI Failed",
  "Web and EDI Pending": "Web and EDI Pending",
  "Web and EDI Verified": "Web and EDI Verified",
  "Weekday": "Weekday",
  "Welcome to weave": "Welcome to weave",
  "Workspace mode is active": "Workspace mode is active",
  "Would you like to adjust your notification settings?": "Would you like to adjust your notification settings?",
  "Yes": "Yes",
  "Yesterday": "Yesterday",
  "Yesterday {{time}}": "Yesterday {{time}}",
  "You are not currently able to place or receive calls within the Weave app.": "You are not currently able to place or receive calls within the Weave app.",
  "You cannot deselect {{locationName}} as its associated device is currently in use on an active call. Please end the call before proceeding": "You cannot deselect {{locationName}} as its associated device is currently in use on an active call. Please end the call before proceeding",
  "You do not have permission to insurance verification for this location": "You do not have permission to insurance verification for this location",
  "You do not have permission to send text messages": "You do not have permission to send text messages",
  "You don't have permission to view Insurance Verification for the location {{ currentLocationName }}. Please switch to one of the following accessible locations: {{ allLocationNames }}": "You don't have permission to view Insurance Verification for the location {{ currentLocationName }}. Please switch to one of the following accessible locations: {{ allLocationNames }}",
  "You have been signed out due to inactivity. Please sign in again.": "You have been signed out due to inactivity. Please sign in again.",
  "You must agree to the terms before proceeding.": "You must agree to the terms before proceeding.",
  "You need to be a <1>Payments Billing Manager</1> or a <3>Super Admin</3> to change these settings.": "You need to be a <1>Payments Billing Manager</1> or a <3>Super Admin</3> to change these settings.",
  "You're a busy bee. Unfortunately, after 30+ locations are selected, our hive is full with too much buzzing. Deselect some locations to resume notifications.": "You're a busy bee. Unfortunately, after 30+ locations are selected, our hive is full with too much buzzing. Deselect some locations to resume notifications.",
  "You've been signed out": "You've been signed out",
  "Your account does not have access to any locations. Contact your administrator for access.": "Your account does not have access to any locations. Contact your administrator for access.",
  "Your application was declined. Please review the information you entered and try again.": "Your application was declined. Please review the information you entered and try again.",
  "Your office missed the transfer from the AI Receptionist. The caller may need assistance.": "Your office missed the transfer from the AI Receptionist. The caller may need assistance.",
  "Your “Net Income” includes what you earn or reasonably expect to earn from employment, investments, retirement, social security benefits and public assistance. You can also include money that someone else deposits regularly into your account (individual or joint) and the amount that you have available to spend from your assets. If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses. Alimony, child support or separate maintenance income need not be included unless relied upon for credit.<1></1><2></2><3>WI Residents Only:</3> If this is an individual account, please also include your spouse’s income.": "Your “Net Income” includes what you earn or reasonably expect to earn from employment, investments, retirement, social security benefits and public assistance. You can also include money that someone else deposits regularly into your account (individual or joint) and the amount that you have available to spend from your assets. If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses. Alimony, child support or separate maintenance income need not be included unless relied upon for credit.<1></1><2></2><3>WI Residents Only:</3> If this is an individual account, please also include your spouse’s income.",
  "Zip Code": "Zip Code",
  "Zip code must be between 4 and 9 digits": "Zip code must be between 4 and 9 digits",
  "appointments": "appointments",
  "delete": "delete",
  "deleted": "deleted",
  "during {{startDate}} to {{endDate}}": "during {{startDate}} to {{endDate}}",
  "last calendar month": "last calendar month",
  "last calendar week": "last calendar week",
  "location": "location",
  "locations": "locations",
  "of": "of",
  "on {{date}}": "on {{date}}",
  "previous 30 days": "previous 30 days",
  "previous 7 days": "previous 7 days",
  "previous day": "previous day",
  "save": "save",
  "saved": "saved",
  "to open the endpoint switcher.": "to open the endpoint switcher.",
  "update": "update",
  "updated": "updated",
  "yesterday": "yesterday",
  "{{ count }} days overdue_one": "{{ count }} days overdue",
  "{{ count }} days overdue_other": "{{ count }} days overdue",
  "{{amount}}/mo suggested payments": "{{amount}}/mo suggested payments",
  "{{amount}}/month": "{{amount}}/month",
  "{{contactLabel}} deleted successfully": "{{contactLabel}} deleted successfully",
  "{{contactLabel}} deletion error": "{{contactLabel}} deletion error",
  "{{count}} Appointment Statuses_one": "{{count}} Appointment Statuses",
  "{{count}} Appointment Statuses_other": "{{count}} Appointment Statuses",
  "{{count}} Location_one": "{{count}} Location",
  "{{count}} Location_other": "{{count}} Location",
  "{{count}} Locations_one": "{{count}} Locations",
  "{{count}} Locations_other": "{{count}} Locations",
  "{{count}} Payers_one": "{{count}} Payers",
  "{{count}} Payers_other": "{{count}} Payers",
  "{{count}} locations missing FAQ page link_one": "{{count}} locations missing FAQ page link",
  "{{count}} locations missing FAQ page link_other": "{{count}} locations missing FAQ page link",
  "{{count}} locations missing Facebook connection_one": "{{count}} locations missing Facebook connection",
  "{{count}} locations missing Facebook connection_other": "{{count}} locations missing Facebook connection",
  "{{count}} locations missing Google connection_one": "{{count}} locations missing Google connection",
  "{{count}} locations missing Google connection_other": "{{count}} locations missing Google connection",
  "{{count}} locations missing a phone number_one": "{{count}} locations missing a phone number",
  "{{count}} locations missing a phone number_other": "{{count}} locations missing a phone number",
  "{{count}} locations missing about page link_one": "{{count}} locations missing about page link",
  "{{count}} locations missing about page link_other": "{{count}} locations missing about page link",
  "{{count}} locations missing an email address_one": "{{count}} locations missing an email address",
  "{{count}} locations missing an email address_other": "{{count}} locations missing an email address",
  "{{count}} locations missing blog link_one": "{{count}} locations missing blog link",
  "{{count}} locations missing blog link_other": "{{count}} locations missing blog link",
  "{{count}} locations missing contact page link_one": "{{count}} locations missing contact page link",
  "{{count}} locations missing contact page link_other": "{{count}} locations missing contact page link",
  "{{count}} locations missing custom review link_one": "{{count}} locations missing custom review link",
  "{{count}} locations missing custom review link_other": "{{count}} locations missing custom review link",
  "{{count}} locations missing form or packet_one": "{{count}} locations missing form or packet",
  "{{count}} locations missing form or packet_other": "{{count}} locations missing form or packet",
  "{{count}} locations missing help center link_one": "{{count}} locations missing help center link",
  "{{count}} locations missing help center link_other": "{{count}} locations missing help center link",
  "{{count}} locations missing map link_one": "{{count}} locations missing map link",
  "{{count}} locations missing map link_other": "{{count}} locations missing map link",
  "{{count}} locations missing other page link_one": "{{count}} locations missing other page link",
  "{{count}} locations missing other page link_other": "{{count}} locations missing other page link",
  "{{count}} locations missing promotional page link_one": "{{count}} locations missing promotional page link",
  "{{count}} locations missing promotional page link_other": "{{count}} locations missing promotional page link",
  "{{count}} locations missing referral page link_one": "{{count}} locations missing referral page link",
  "{{count}} locations missing referral page link_other": "{{count}} locations missing referral page link",
  "{{count}} locations missing shop link_one": "{{count}} locations missing shop link",
  "{{count}} locations missing shop link_other": "{{count}} locations missing shop link",
  "{{count}} locations missing web page link_one": "{{count}} locations missing web page link",
  "{{count}} locations missing web page link_other": "{{count}} locations missing web page link",
  "{{count}} locations need schedule configuration_one": "{{count}} locations need schedule configuration",
  "{{count}} locations need schedule configuration_other": "{{count}} locations need schedule configuration",
  "{{count}} locations without an address_one": "{{count}} locations without an address",
  "{{count}} locations without an address_other": "{{count}} locations without an address",
  "{{count}} matching locations_one": "{{count}} matching locations",
  "{{count}} matching locations_other": "{{count}} matching locations",
  "{{count}} missing button labels_one": "{{count}} missing button labels",
  "{{count}} missing button labels_other": "{{count}} missing button labels",
  "{{count}} missing button links_one": "{{count}} missing button links",
  "{{count}} missing button links_other": "{{count}} missing button links",
  "{{count}} pets_one": "{{count}} pets",
  "{{count}} pets_other": "{{count}} pets",
  "{{count}} unknown validation errors_one": "{{count}} unknown validation errors",
  "{{count}} unknown validation errors_other": "{{count}} unknown validation errors",
  "{{current}} / {{max}}": "{{current}} / {{max}}",
  "{{deviceName}} is currently connected": "{{deviceName}} is currently connected",
  "{{fullName}} is approved for a CareCredit credit card with a <b>{{amount}} credit limit.</b>": "{{fullName}} is approved for a CareCredit credit card with a <b>{{amount}} credit limit.</b>",
  "{{interest}}% APR and Fixed Monthly Payments Required for {{months}} Months**": "{{interest}}% APR and Fixed Monthly Payments Required for {{months}} Months**",
  "{{label}} is required.": "{{label}} is required.",
  "{{months}} Months": "{{months}} Months",
  "{{months}} Months @ {{interestRate}}%": "{{months}} Months @ {{interestRate}}%",
  "{{months}} months": "{{months}} months",
  "{{months}} mos": "{{months}} mos",
  "{{selected}} of {{total}} Locations Selected": "{{selected}} of {{total}} Locations Selected",
  "{{taskCount}} tasks": "{{taskCount}} tasks",
  "{{years}} yrs": "{{years}} yrs",
  "{{years}} yrs, {{months}} mos": "{{years}} yrs, {{months}} mos",
  "⚠️ The selected workspace is no longer available. Please select your locations.": "⚠️ The selected workspace is no longer available. Please select your locations."
}
